import { ActionContext, ActionTree } from "vuex";
import { GetterTree } from "vuex";
import { FunctionSetting } from "@/model/FunctionSetting";
import { ShakenStorage } from "@/service/storage";

export const getFunctionSettingConfigKey = () => ShakenStorage.getSessionKey("function-setting:config");
export const getFunctionSettingStateKey = () => ShakenStorage.getSessionKey("function-setting:state");

const initialState: FunctionSetting = {
    groupCd: null,
    shatenCd: null,
    kyotenCd: null,
    isCanQuickMitsumori: null,
    isCanJizenMitsumori: null,
    /** 2023-10-19 invoice [START] */
    isExcludingTax: null,
    /** 2023-10-19 invoice [END] */
    /** 2024-05-02 nextage [START] */
    isNextageCustom: null,
    /** 2024-05-02 nextage [END] */
    isUseNisseiren: null,
    isDebug: null,
    /** 2023-01-26 sh #8180(BQR1080) add course change. [START] */
    isCanChangeCourse: null,
    /** 2023-01-26 sh #8180(BQR1080) add course change. [END] */
    formatSagyouAsHeader: null,
    isReferReservation: null,
    isEstimateBuhin: null,
    isCanExtendsImage: null,
    isReceiveInfo: null,
    isNewInformation: null,
    counterNewInfo:0,

    isUseIppanSeibi: null,
    isInspectionLessInput: null,
    isLaurelCustom: null,
    isEstimateAssignment: null,

    freeOfChargeNm: "無償対応",
    isShowMaintepack: null,

    freeOfChargeNm1: "無償",
    freeOfChargeNm2: "対応",
    freeOfChargeNm3: "対応",
    couponLabel: "割引/クーポン",
    optionLabel: "手数料/オプション",

    scenarioNm: "見積",
    scenarioNo: null,

    sideTabs: [],
    factoryTabs: [],
    userTabs: [],
    factorySelectCombo: [],
    userSelectCombo: []
};

const setFreeOfChargeNm = (state: FunctionSetting, freeOfChargeNm?: string | null) => {
  if (freeOfChargeNm && freeOfChargeNm !== "") {
    state.freeOfChargeNm = freeOfChargeNm;
    state.freeOfChargeNm1 = freeOfChargeNm.substr(0, 2);
    state.freeOfChargeNm2 = freeOfChargeNm.substr(2, 2);
    state.freeOfChargeNm3 = freeOfChargeNm.substr(2);
  }
};

const actions: ActionTree<FunctionSetting, any> = {
  setState(
    { commit }: ActionContext<FunctionSetting, any>,
    payload: FunctionSetting
  ): void {
    commit("setState", payload);
  },
  clearState({ commit }: ActionContext<FunctionSetting, any>): void {
    commit("clearState");
  },
  setStateSession({ commit }: ActionContext<FunctionSetting, any>): void {
    commit("setStateSession");
  },
  setInformation(
    { commit }: ActionContext<FunctionSetting, any>,
    payload: number
  ): void {
    commit("setShakenShurui", payload);
  },
};

const mutations = {
  setState(state: FunctionSetting, payload: FunctionSetting) {
    Object.assign(state, payload);
    setFreeOfChargeNm(state, payload.freeOfChargeNm);
    window.sessionStorage.setItem(getFunctionSettingConfigKey(), "1");
    window.sessionStorage.setItem(getFunctionSettingStateKey(), JSON.stringify(state));
  },
  clearState(state: FunctionSetting) {
    Object.assign(state, { ...initialState });
  },
  // FunctionSettingをセッションから回収してラグを抑える
  setStateSession(state: any) {
    const obj = window.sessionStorage.getItem(getFunctionSettingStateKey());
    if (!obj) {
      return;
    }
    let config: FunctionSetting;
    try {
      config = JSON.parse(obj);
    } catch (error) {
      window.sessionStorage.removeItem(getFunctionSettingStateKey());
      window.sessionStorage.removeItem(getFunctionSettingConfigKey());
      return;
    }
    Object.assign(state, config);
    setFreeOfChargeNm(state, config.freeOfChargeNm);
  },
  setFreeOfChargeNm(state: FunctionSetting, payload: {txt1: string,txt2: string,txt3: string} ) {
    state.freeOfChargeNm = payload.txt1 + payload.txt3;
    state.freeOfChargeNm1 = payload.txt1;
    state.freeOfChargeNm2 = payload.txt2;
    state.freeOfChargeNm3 = payload.txt3;
    window.sessionStorage.setItem(getFunctionSettingStateKey(), JSON.stringify(state));
  },
  setScenarioNo(state: FunctionSetting, payload: string ) {
    state.scenarioNo = payload;
  },
  setInformation(state: FunctionSetting, payload: number ) {
    state.isNewInformation = payload;
    state.counterNewInfo = Number(payload);
  },
};

const getters: GetterTree<FunctionSetting, any> = {
  currentState(state: FunctionSetting): any {
    return state;
  },
  /** 2021-07-30 sh #6989 implements quick mitsumori(priority 2). [START] */
  isCanQuickMitsumori(state: FunctionSetting): any {
    return (state && state.isCanQuickMitsumori == 1);
  },
  /** 2021-07-30 sh #6989 implements quick mitsumori(priority 2). [END] */
  /** 2021-08-19 sh #7350 add isCanJizenMitsumori. [START] */
  isCanJizenMitsumori(state: FunctionSetting): any {
    return (state && state.isCanJizenMitsumori == 1);
  },
  /** 2021-08-19 sh #7350 add isCanJizenMitsumori. [END] */

  /** 2023-10-19 invoice [START] */
  isExcludingTax(state: FunctionSetting): any {
    return (state && state.isExcludingTax == 1);
  },

  taxLabel(state: FunctionSetting): string {
    if (state) {
      return state.isExcludingTax == 1 ? '税抜':'税込';
    } else {
      return "";
    }
  },
  /** 2023-10-19 invoice [END] */
  /** 2024-05-02 nextage [START] */
  isNextageCustom(state: FunctionSetting): any {
    return (state && state.isNextageCustom == 1);
  },
  isReferReservation(state: FunctionSetting): any {
    return (state && state.isReferReservation == 1);
  },
  isEstimateBuhin(state: FunctionSetting): any {
    return (state && state.isEstimateBuhin == 1);
  },
  isCanExtendsImage(state: FunctionSetting): any {
    return (state && state.isCanExtendsImage == 1);
  },
  /** 2024-05-02 nextage [END] */
  isUseNisseiren(state: FunctionSetting): number | null {
    return (state && state.isUseNisseiren != null) ? Number(state.isUseNisseiren): null;
  },
  isReceiveInfo(state: FunctionSetting): any {
    return (state && state.isReceiveInfo && state.isReceiveInfo > 0);
  },
  isNewInformation(state: FunctionSetting): any {
    return (state && state.isNewInformation && state.isNewInformation > 0);
  },
  counterNewInfo(state: FunctionSetting): any {
    if(state && state.counterNewInfo != null) {
      return state.counterNewInfo;
    } else {
      return -1;
    }
  },
  isUseIppanSeibi(state: FunctionSetting): boolean | null {
    return (state && state.isUseIppanSeibi == 1);
  },
  isInspectionLessInput(state: FunctionSetting): boolean | null {
    return (state && state.isInspectionLessInput == 1);
  },
  isLaurelCustom(state: FunctionSetting): boolean | null {
    return (state && state.isLaurelCustom == 1);
  },
  isEstimateAssignment(state: FunctionSetting): boolean | null {
    return (state && state.isEstimateAssignment == 1);
  },
  isShowMaintepack(state: FunctionSetting): boolean | null {
    return (state && state.isShowMaintepack == 1);
  },
  sideTabList(state: FunctionSetting): any {
    return (state.sideTabs);
  },
  sideTabListQuick(state: FunctionSetting): any {
    // return (state && state.isNextageCustom == 1);
    return ( [ 
      { "title1": "法定費用・車検諸費用","title2": "小計","router": "userinspectioncost"
        ,"calcLabel": "","tabId":"", "lock":"", "mode":"" },
      { "title1": (state.couponLabel && state.couponLabel !== "" ? state.couponLabel : "割引/クーポン")
        ,"title2": ""    ,"router": "quickdiscountcoupon"
        ,"calcLabel": "","tabId":"", "lock":"", "mode":"" },
      { "title1": "おすすめ整備 小計"   ,"title2": ""    ,"router": "userrecommend" 
        ,"calcLabel": "","tabId":"", "lock":"", "mode":"" },
      { "title1": "車検代金 合計"       ,"title2": ""    ,"router": "paymentdetail" 
        ,"calcLabel": "","tabId":"", "lock":"", "mode":"" },
    ]);
  },
  screenTabListFactory(state: FunctionSetting): any {
    return (state.factoryTabs);
  },
  screenTabListUser(state: FunctionSetting): any {
    return (state.userTabs);
  },
  selectComboListFactory(state: FunctionSetting): any {
    return (state.factorySelectCombo);
  },
  selectComboListUser(state: FunctionSetting): any {
    return (state.userSelectCombo);
  },
  
  

  /** 2021-09-10 sh #7372 fix button of jizen mitsumori.(check JizenCd from MD-0002 ) [START] */
  isValid(state: FunctionSetting): boolean {
    if (state && state.groupCd != null && state.shatenCd != null && state.kyotenCd != null) {
        return true;
    }
    return false;
  },
  /** 2021-09-10 sh #7372 fix button of jizen mitsumori.(check JizenCd from MD-0002 ) [END] */

  /** 2023-01-26 sh #8180(BQR1080) add course change. [START] */
  isCanChangeCourse(state: FunctionSetting): any {
    return (state && state.isCanChangeCourse == 1);
  },
  /** 2023-01-26 sh #8180(BQR1080) add course change. [END] */
  freeOfChargeLabelFull(state: FunctionSetting): any {
    if ( state && state.freeOfChargeNm1 != null && state.freeOfChargeNm3 != null ) {
      return state.freeOfChargeNm1 + state.freeOfChargeNm3;
    }
    return "";
  },
  freeOfChargeLabelMini(state: FunctionSetting): any {
    if ( state && state.freeOfChargeNm1 != null && state.freeOfChargeNm2 != null ) {
      return { nm1:state.freeOfChargeNm1 , nm2:state.freeOfChargeNm2 };
    }
    return { nm1: "" , nm2: "" };
  },
  freeOfChargeLabelMsg(state: FunctionSetting): any {
    if ( state && state.freeOfChargeNm1 != null ) {
      return state.freeOfChargeNm1 +"作業";
    }
    return "";
  },
  couponLabel(state: FunctionSetting): string {
    if (state && state.couponLabel != null && state.couponLabel !== "") {
      return state.couponLabel;
    }
    // 変更してない時の初期表示
    return "割引/クーポン";
  },
  optionLabel(state: FunctionSetting): string {
    if (state && state.optionLabel != null && state.optionLabel !== "") {
      return state.optionLabel;
    }
    // 変更してない時の初期表示
    return "手数料/オプション";
  },

  nameOfScenario(state: FunctionSetting): any {
    if ( state && state.scenarioNo != null ) {
      return state.scenarioNm + state.scenarioNo;
    }
    return "";
  },
};

const namespaced: boolean = true;
export default {
  namespaced,
  state: { ...initialState },
  getters,
  actions,
  mutations
};
